import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

const SubTable = require("./Subtable.vue").default;

const subtablesRefs = {};

export const destroySubTable = function ({ subtableRef }) {
  const table = subtablesRefs[subtableRef];
  if (table) {
    table.destroyStore();
    table.$el.remove();
    delete subtablesRefs[subtableRef];
  }
};

export const createSubTable = function ({
  parentStoreName,
  parentId,
  subTableProps,
  storePrefix,
  store,
  rowIndex,
}) {
  if (rowIndex == null) return;

  const id = parentId
    ? `table#${parentId} > tbody > tr#row-${rowIndex}`
    : `#row-${rowIndex}`;

  const row = document.querySelector(id);
  const table = new Vue(SubTable);

  table.parentStoreName = parentStoreName;
  table.subtableProps = subTableProps;
  const storeUniqueName = `${storePrefix}-${uuidv4()}`;
  table.subtableStore = {
    name: storeUniqueName,
    store: () => store,
  };

  table.$mount();
  table.$on("onClose", () => {
    table.$el.remove();
  });

  subtablesRefs[storeUniqueName] = table;

  table.$nextTick(() => {
    $(row).after(table.$el);
  });

  return storeUniqueName;
};
